<template>
    <div>
        <p>{{ row.orderRate | formatEmpty | formatPercent }}</p>
    </div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
};
</script>